import * as types from "@/store/mutation-types.js";
import config from "@/assets/js/config.js";
import userService from "@/api/userService.js";
import vue from "vue";
import inforMan from "./inforMan.js";
import appCenter from "./appCenter.js";
import coreEntry from '@core/entry.js'
const header = ()=>import("@/components/HEAD.vue"); // 首页
const aside = ()=>import("@/components/ASIDE.vue"); // 新高呈 - 左侧菜单
const systemHeader = ()=>import("@/components/systemHead.vue"); // 系统首页
const sideMenu = ()=>import("@core/components/LEFT.vue");
const index = ()=>import("../views/index.vue"); // 首页
const websiteSetting = ()=>import("../views/settingMan/websiteSetting.vue");
const fileSetting = ()=>import("@core/modules/settingMan/fileSetting.vue");
const domainSetting = ()=>import("../views/settingMan/domainSetting.vue");
const sslSetting = () => import("../views/settingMan/sslSetting.vue");
const imgSetting = ()=>import("@core/modules/settingMan/imgSetting.vue");
const memberSetting = () => import("../views/settingMan/memberSetting.vue"); 
const pageNotFound = ()=>import("../views/pageNotFound.vue");//404
const iframe = () => import ("@core/components/iframe.vue");
const onLineSetting = ()=>import("../views/onLineSetting/onlineSetting.vue");

const enquiryForm = ()=>import("../views/enquiryForm/enquiryForm.vue");//在线询价
Vue.use(VueRouter);

let router = new VueRouter({
  base: "manage",
  mode: "history",
  suppressTransitionError: process.env.NODE_ENV.includes('production'), // 生产环境下不抛出异常
  routes: [
    {
      path: "/manage/",
      redirect: {
        name: "navigation"
      }
    },
    {
      path: "/",
      redirect: {
        name: "navigation"
      }
    },
    {
      // 首页
      path: "/index/",
      name: "index",
      components: {
        header: systemHeader,
        aside: aside,
        default: index
      },
      meta: {}
    },
    {
      // 站点设置
      path: "/websiteSetting",
      name: "websiteSetting",
      components: {
        header: header,
        aside: aside,
        left: sideMenu,
        default: websiteSetting
      },
      meta: {}
    },
    {
      // 域名设置
      path: "/domainSetting",
      name: "domainSetting",
      components: {
        header: header,
        aside: aside,
        left: sideMenu,
        default: domainSetting
      },
      meta: {}
    },
    {
      // 文件库设置
      path: "/fileSetting",
      name: "fileSetting",
      components: {
        header: header,
        aside: aside,
        left: sideMenu,
        default: fileSetting
      },
      meta: {}
    },
    {
      // ssl设置
      path: "/sslSetting",
      name: "sslSetting",
      components: {
        header: header,
        aside: aside,
        left: sideMenu,
        default: sslSetting
      },
      meta: {}
    },
    {
      // 在线客服
      path: "/onLineSetting",
      name: "onLineSetting",
      components: {
        header: header,
        aside: aside,
        left: sideMenu,
        default: onLineSetting
      },
      meta: {}
    },
    {
      // 在线询价
      path: "/enquiryForm",
      name: "enquiryForm",
      components: {
        header: header,
        aside: aside,
        left: sideMenu,
        default: enquiryForm
      },
      meta: {}
    },
    {
      // 图片库设置应用全网
      path: "/imgSetting",
      name: "imgSetting",
      components: {
        header: header,
        aside: aside,
        left: sideMenu,
        default: imgSetting
      },
      meta: {}
    },
    {
      path: "/memberSetting",
      name: "memberSetting",
      components: {
        header: header,
        aside: aside,
        left: sideMenu,
        default: memberSetting
      },
      meta: {}
    },
    {
      // iframe
      path: "/iframe",
      name: "iframe",
      components: {
        header: header,
        aside: aside,
        left: sideMenu,
        default: iframe
      },
      meta: {}
    },
    {
      //404
      path: "/pageNotFound",
      name: "pageNotFound",
      components: {
        header: header,
        default: pageNotFound,
        left: sideMenu
      }
    },
    {
      path: "*",
      redirect: {
        name: "pageNotFound"
      }
    },...inforMan, ...appCenter,
    coreEntry.getModuleConfig('router', 'visual')
  ]
});

import{getAppByUrl} from '@/assets/js/application.js'

// 权限拦截
router.beforeEach((to, from, next) => {
  let pathArr = to.path.split('/');
  let activeMenuItem = to.meta.parentRoot || `/${pathArr[1]}`;
  let menuData = getAppByUrl(activeMenuItem)
  router.app.$options.store.commit(types.SETSELECTMENU,menuData)

  let tenantId = to.query.tenantId;
  let isMobile = to.query.isMobile;
  let TOKEN = to.query.TOKEN?to.query.TOKEN : router.app.$options.store.state.TOKEN;
  let unGetPermission = to.meta.unGetPermission // 不权限获取拦截
  tenantId && router.app.$options.store.commit(types.UPDATETENANTID, tenantId);
  tenantId && router.app.$options.store.commit(types.UPDATEMOBILE, isMobile);
  router.app.$options.store.state.TOKEN =  TOKEN;
  router.app.$options.store.dispatch("getLoginUser", {TOKEN, unGetPermission, next});
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js